
import { TranslationsByLanguage } from './types';

export type CommonTranslationKey =
  | 'common.cancel'
  | 'common.confirm'
  | 'common.create'
  | 'common.back'
  | 'common.next'
  | 'common.submit'
  | 'common.loading'
  | 'common.error'
  | 'common.errorOccurred'
  | 'common.errorLoading'
  | 'common.loadMore'
  | 'common.showMore'
  | 'common.showLess'
  | 'common.viewAll'
  | 'common.viewMore'
  | 'common.viewDetails'
  | 'common.viewProfile'
  | 'common.share'
  | 'common.delete'
  | 'common.edit'
  | 'common.save'
  | 'common.update'
  | 'common.tryAgain'
  | 'common.success'
  | 'common.details'
  | 'common.all'
  | 'common.search'
  | 'common.filterByType'
  | 'common.allExpressions'
  | 'common.details'
  | 'common.close'
  | 'common.continue';

export const commonTranslations: TranslationsByLanguage = {
  en: {
    'common.cancel': 'Cancel',
    'common.confirm': 'Confirm',
    'common.create': 'Create',
    'common.back': 'Back',
    'common.next': 'Next',
    'common.submit': 'Submit',
    'common.loading': 'Loading',
    'common.error': 'Error',
    'common.errorOccurred': 'An error occurred',
    'common.errorLoading': 'Error loading data',
    'common.loadMore': 'Load more',
    'common.showMore': 'Show more',
    'common.showLess': 'Show less',
    'common.viewAll': 'View all',
    'common.viewMore': 'View more',
    'common.viewDetails': 'View details',
    'common.viewProfile': 'View profile',
    'common.share': 'Share',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.save': 'Save',
    'common.update': 'Update',
    'common.tryAgain': 'Try again',
    'common.success': 'Success',
    'common.details': 'Details',
    'common.all': 'All',
    'common.search': 'Search',
    'common.filterByType': 'Filter by type',
    'common.allExpressions': 'All expressions',
    'common.close': 'Close',
    'common.continue': 'Continue',
  },
  fr: {
    'common.cancel': 'Annuler',
    'common.confirm': 'Confirmer',
    'common.create': 'Créer',
    'common.back': 'Retour',
    'common.next': 'Suivant',
    'common.submit': 'Soumettre',
    'common.loading': 'Chargement',
    'common.error': 'Erreur',
    'common.errorOccurred': 'Une erreur est survenue',
    'common.errorLoading': 'Erreur de chargement des données',
    'common.loadMore': 'Charger plus',
    'common.showMore': 'Afficher plus',
    'common.showLess': 'Afficher moins',
    'common.viewAll': 'Voir tout',
    'common.viewMore': 'Voir plus',
    'common.viewDetails': 'Voir les détails',
    'common.viewProfile': 'Voir le profil',
    'common.share': 'Partager',
    'common.delete': 'Supprimer',
    'common.edit': 'Modifier',
    'common.save': 'Enregistrer',
    'common.update': 'Mettre à jour',
    'common.tryAgain': 'Réessayer',
    'common.success': 'Succès',
    'common.details': 'Détails',
    'common.all': 'Tous',
    'common.search': 'Rechercher',
    'common.filterByType': 'Filtrer par type',
    'common.allExpressions': 'Toutes les expressions',
    'common.close': 'Fermer',
    'common.continue': 'Continuer',
  }
};
